import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const placeholder = 'https://placehold.co/300x450.png?text=No+Poster';

const PosterCard = ({
  src,
  title,
  subtitle,
  onClick,
  width = 170,
  ratio = '2 / 3',
  overlay,
  badge,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        flex: '0 0 auto',
        width,
        scrollSnapAlign: 'start',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform .25s ease',
        '&:hover': onClick ? { transform: 'translateY(-4px)' } : {},
      }}
    >
      <Box
        sx={{
          position: 'relative',
          borderRadius: 2.5,
          overflow: 'hidden',
          aspectRatio: ratio,
          bgcolor: 'background.paper',
          boxShadow: (t) =>
            t.palette.mode === 'dark'
              ? '0 6px 22px rgba(0,0,0,0.45)'
              : '0 4px 14px rgba(0,0,0,0.10)',
          border: (t) => `1px solid ${t.palette.divider}`,
          '&:hover .poster-overlay': { opacity: 1 },
          '&:hover img': { transform: 'scale(1.05)' },
        }}
      >
        <Box
          component="img"
          src={src || placeholder}
          alt={title}
          loading="lazy"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: 'transform .35s ease',
          }}
        />
        {badge && (
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              left: 8,
              px: 1,
              py: 0.25,
              borderRadius: 1,
              fontSize: 11,
              fontWeight: 700,
              bgcolor: 'rgba(0,0,0,0.65)',
              color: '#fff',
              backdropFilter: 'blur(6px)',
            }}
          >
            {badge}
          </Box>
        )}
        {overlay && (
          <Box
            className="poster-overlay"
            sx={{
              position: 'absolute',
              inset: 0,
              opacity: 0,
              transition: 'opacity .25s ease',
              background:
                'linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.85) 100%)',
              display: 'flex',
              alignItems: 'flex-end',
              p: 1.25,
              color: '#fff',
            }}
          >
            {overlay}
          </Box>
        )}
      </Box>
      {(title || subtitle) && (
        <Box sx={{ mt: 1 }}>
          {title && (
            <Typography variant="body2" noWrap sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="caption" color="text.secondary" noWrap component="div">
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default PosterCard;
